<template>
  <f7-page name="editReferral">
    <bc-navbar></bc-navbar>
    <div class="page_single layout_fullwidth_padding">
      <page-header :title="title" :backUrl="backLink"> </page-header>
    </div>

    <f7-list
      form
      class="u-mb2 no-hairlines no_list_bootm_border margin_top_none"
    >
      <f7-list-item>
        <f7-label>First Name</f7-label>
        <f7-input
          type="text"
          name="firstName"
          v-model="formData.firstName"
          v-validate="'required|alpha'"
        />
        <span v-show="errors.has('firstName')" class="error-message">
          {{ errors.first("firstName") }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Last Name</f7-label>
        <f7-input
          type="text"
          name="lastName"
          v-model="formData.lastName"
          v-validate="'required|alpha'"
        />
        <span v-show="errors.has('lastName')" class="error-message">
          {{ errors.first("lastName") }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Mobile Phone</f7-label>
        <div
          class="item-input item-input-field not-empty-state"
          masked="true"
          data-vv-id="6"
          aria-invalid="false"
        >
          <vue-tel-input
            data-vv-name="Phone"
            v-model="formData.referralContactPhone"
            :phone="formData.referralContactPhone"
            v-validate.continues="{ phone: true }"
            :invalid="invalidPhone"
          ></vue-tel-input>
        </div>
        <span v-if="invalidPhone" class="error-message">
          {{ errors.first("Phone") }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Comment (optional)</f7-label>
        <f7-input
          type="textarea"
          name="commentText"
          v-model="formData.commentText"
        />
      </f7-list-item>
      <f7-list-item>
        <div class="fx align-items-center justify-content-between">
          <button
            :disabled="invalidForm"
            type="button"
            class="button"
            :style="buttonStyle"
            @click="onSave()"
          >
            Save Changes
          </button>
          <button type="button" class="button u-danger" @click="onRemove()">
            Delete
          </button>
        </div>
      </f7-list-item>
    </f7-list>
    <loader :show="loading" />

    <f7-actions :opened="showDeleteConfirmation">
     
      <f7-actions-group>
        <f7-actions-label
          >Are you sure you want to delete this referral?</f7-actions-label
        >
        <div class="confirm-actions fx align-items-center justify-content-between">
              <button
                type="button"
                class="button u-danger"
                @click="confirmDelete()"
              >
                Delete
              </button>
              <button
                type="button"
                class="button"
                @click="showDeleteConfirmation = false"
              >
                Cancel
              </button>
            </div>
      </f7-actions-group>
    </f7-actions>
  </f7-page>
</template>

<script>
import { PAGES } from '../../shared/routes.constants'
import { notify } from '@/shared/notifications.js'
import { mapActions, mapState } from 'vuex'
import Loader from '@components/loader.vue'
export default {
  name: 'referral-form-page',
  components: {
    loader: Loader
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization
    }),
    invalidForm () {
      return this.errors.any()
    },
    invalidPhone () {
      return this.errors.first('Phone')
    },
    buttonStyle () {
      return {
        color: this.customization.fontColor,
        'background-color': this.customization.mainColor
      }
    }
  },
  mounted () {
    this.loading = true
    const historyId = this.$route.params.id
    if (!historyId) {
      return this.$router.load({ url: 'error' })
    }
    this.getReferral({ referralHistoryId: historyId })
      .then((res) => {
        if (!res.success) {
          throw new Error('Something went wrong')
        }
        this.setFormData(res.model)
      })
      .catch(() => this.$router.load({ url: 'error' }))
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    ...mapActions({
      getReferral: 'recommendFriend/getReferral',
      editReferral: 'recommendFriend/editReferral',
      deleteReferral: 'recommendFriend/deleteReferral'
    }),
    setFormData (data) {
      const {
        referralHistoryId,
        commentText,
        firstName,
        lastName,
        referralContactPhone
      } = data
      this.formData = {
        referralHistoryId,
        firstName,
        lastName,
        referralContactPhone,
        commentText
      }
    },
    onSave () {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit () {
      this.loading = true
      const {
        referralHistoryId,
        firstName,
        lastName,
        referralContactPhone,
        commentText
      } = this.formData
      const req = {
        referralHistoryId: referralHistoryId,
        fullName: firstName + ' ' + lastName,
        phone: referralContactPhone,
        commentText
      }
      this.editReferral(req)
        .then((res) => {
          if (res.success) {
            notify.success('Saved!')
            this.$router.back()
          } else {
            notify.error('Error during save refarral')
          }
        })
        .catch(() => {
          notify.error('Error during save refarral')
        })
        .finally(() => {
          this.loading = false
        })
    },
    onRemove () {
      this.showDeleteConfirmation = true
    },
    confirmDelete () {
      this.showDeleteConfirmation = false
      this.loading = true
      this.deleteReferral(this.formData.referralHistoryId)
        .then(() => {
          notify.success('Referral was deleted')
          this.$router.load({ url: this.backLink })
        })
        .catch(() => {
          notify.error('Error during delete refarral')
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  data () {
    return {
      title: 'Edit referral',
      backLink: PAGES.RecommendAFriendHistory,
      loading: false,
      showDeleteConfirmation: false,
      formData: {
        referralHistoryId: null,
        firstName: null,
        lastName: null,
        referralContactPhone: null,
        commentText: null
      }
    }
  }
}
</script>

<style scoped>
.confirm-actions{
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// edit-referral.vue?3dac1ffc